<template>
  <div>
    <a
      :href="link.url"
      target="_blank"
      class="block relative bg-gray-100"
      style="padding-bottom: 66.666667%"
    >
      <img v-if="link.cover" :src="link.cover" class="absolute w-full h-full object-cover" />
      <div v-else class="absolute w-full h-full inline-flex items-center justify-center">
        <div class="flex flex-col items-center space-y-4">
          <svg viewBox="0 0 24 24" fill="currentColor" class="h-12 w-12 text-gray-600">
            <path
              d="M10 6v2H5v11h11v-5h2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1
              1 0 0 1 1-1h6zm11-3v8h-2V6.413l-7.793
              7.794-1.414-1.414L17.585 5H13V3h8z"
            />
          </svg>
        </div>
      </div>
    </a>
    <div v-if="!withoutActions" class="flex">
      <portal :to="`links-${link.id}-actions`">
        <BaseButton ghost squared @click="copyUrl" class="flex-1 text-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            class="inline-block w-4 h-4 focus:outline-none"
            v-tip="{ content: 'copy to clipboard' }"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path
              d="M7 6V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v14a1
              1 0 0 1-1 1h-3v3c0 .552-.45 1-1.007 1H4.007A1.001
              1.001 0 0 1 3 21l.003-14c0-.552.45-1 1.007-1H7zM5.003
              8L5 20h10V8H5.003zM9 6h8v10h2V4H9v2z"
            />
          </svg>
        </BaseButton>
      </portal>
    </div>
  </div>
</template>

<script>
import copyToClipboard from '@/utils/copy-to-clipboard';

export default {
  name: 'AssetableLink',
  props: {
    withoutActions: Boolean,
    link: {
      type: Object,
      required: true,
    },
  },
  methods: {
    copyUrl() {
      copyToClipboard(this.link.url);
    },
  },
};
</script>
